/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Owner_OtherInputs */

const vi_media_owner_other = /** @type {(inputs: Media_Owner_OtherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khác`)
};

/**

* @param {Media_Owner_OtherInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_owner_other = /** @type {((inputs?: Media_Owner_OtherInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Owner_OtherInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_owner_other(inputs)
});